import ShModel from 'sh-www/models/sh-model';
import { attr, belongsTo, hasMany } from '@ember-data/model';

export const PRODUCTION_STATUS_CANCELLED = -10;
export const PRODUCTION_STATUS_PRE_PRODUCTION = 0;
export const PRODUCTION_STATUS_PRODUCTION = 10;
export const PRODUCTION_STATUS_POST_PRODUCTION = 20;
export const PRODUCTION_STATUS_DONE = 30;

export const PRODUCTION_STATUSES = {
  [PRODUCTION_STATUS_CANCELLED]: 'Cancelled',
  [PRODUCTION_STATUS_PRE_PRODUCTION]: 'Pre-Production',
  [PRODUCTION_STATUS_PRODUCTION]: 'Production',
  [PRODUCTION_STATUS_POST_PRODUCTION]: 'Post-Production',
  [PRODUCTION_STATUS_DONE]: 'Done',
};

class Production extends ShModel {
  @attr('string') title;
  @attr('string') description;
  @attr('number') status;
  @attr('string') slug;
  @attr('number') amount;
  @attr('number') budget;
  @attr('number') spent;
  @attr('number') remaining;
  @attr('date') deadline;

  @belongsTo('company', { async: false, inverse: null }) company;
  @belongsTo('company', { async: false, inverse: null }) client;
  @hasMany('assignment', { async: false, inverse: null }) postings;
  @hasMany('application', { async: false, inverse: null }) projects;
  @hasMany('shGeneralInvoice', { async: false, inverse: null }) invoices;

  get statusText() {
    return PRODUCTION_STATUSES[this.status];
  }
}

export default Production;
